import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import { GiftItemInfoData, GiftItemInfoListData } from './giftItemInfo.interface';

// 목록 조회
export const giftItemInfoListStatusAtom = atom<QueryStatus>({
  key: 'giftItemInfoListStatusAtom',
  default: 'idle',
});

export const giftItemInfoListDataAtom = atom<GiftItemInfoListData | null>({
  key: 'giftItemInfoListDataAtom',
  default: null,
});

// 단건 조회
export const giftItemInfoStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftItemInfoStatusAtomFamily',
  default: 'idle',
});

export const giftItemInfoDataAtomFamily = atomFamily<GiftItemInfoData | null, string>({
  key: 'giftItemInfoDataAtomFamily',
  default: null,
});
